import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Col, Row, Form, Input, Card, Upload, Button, message } from "antd";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";
import { RcFile } from "antd/lib/upload";
import { IoArrowBackOutline } from "react-icons/io5";
import { Select } from "antd";
import type { UploadProps } from "antd";
import { editAward, getSliderByID, updateAward, UpdateSlider } from "../../../utils/API";
import axios from "axios";
import { BsUpload } from "react-icons/bs";
import { FaArrowLeft } from "react-icons/fa";

interface AwardFormValues {
  title: string;
  file: string;
}

const AwardEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>(); // Get ID from URL
  const navigate = useNavigate();
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [fileList, setFileList] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm(); // Initialize form instance

  useEffect(() => {
    if (id) {
      getAwardData();
    }
  }, [id]);

  const getAwardData = async () => {
    const imageLink = process.env.REACT_APP_Image_URL;
    try {
      const response = await editAward(id);
      const { title, file } = response.data.award;
      form.setFieldsValue({ title, file });
      // setFileList([image]);
      const imageUrl = `${process.env.REACT_APP_Image_URL}/awards/${file}`;
      setFileList([{ uid: '1', name: file, status: 'done', url: imageUrl }]);
      // setImageUrl(imageLink + "/awards/" + file);
      // setImageUrl(imageLink + "/awards/" + image);
      // setLoading(false);
    } catch (error) {
      console.error("Error fetching art data:", error);
      // setLoading(false);
    }
  };

  const handleAddImage: UploadProps["onChange"] = ({
    fileList: newFileList,
  }) => {
    if (newFileList.length > 0) {
      const file = newFileList[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        setImageUrl(e.target?.result as string);
      };
      reader.readAsDataURL(file.originFileObj as RcFile);
    } else {
      setImageUrl(null);
    }
    setFileList(newFileList);
  };

  const handleImage = ({ fileList }: any) => {
    setFileList(fileList);
  };

  // const handleReplaceImage: UploadProps["onChange"] = ({
  //   fileList: newFileList,
  // }) => {
  //   if (newFileList.length > 0) {
  //     const file = newFileList[0];
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       setImageUrl(e.target?.result as string);
  //     };
  //     reader.readAsDataURL(file.originFileObj as RcFile);
  //   } else {
  //     setImageUrl(null);
  //   }
  //   setFileList(newFileList);
  // };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("title", form.getFieldValue("title"));
      if (fileList.length > 0) {
        formData.append("file", fileList[0].originFileObj);
      }
      // console.log("fileList", fileList);
      const response:any = await updateAward(id, formData);
      message.success(response.message);
      setLoading(false);
      navigate("/backend/awards");
    } catch (error) {
      setLoading(false);
      console.error("Update failed:", error);
    }
  };

  return (
    <div className="">
      <Row className="m-2" align="middle">
        <Col span={16}>
          <h2 className="text-2xl font-bold">Edit Award</h2>
        </Col>

        <Col span={8} className="d-flex justify-end">
          <Link to={"/backend/awards"}>
            <button className="d-flex justify-content-center align-items-center w-full border btn-brand">
              <FaArrowLeft className="me-2" />
              <div className="ms-2">Back</div>
            </button>
          </Link>
        </Col>
      </Row>
      {loading ? (
        <LoadingOutlined />
      ) : (
        <Form<AwardFormValues>
          form={form}
          className="bg-white"
          onFinish={handleSubmit}
        >
          <Card style={{ backgroundColor: "#ffffff" }}>
            <Row
              className="border border-warning-2 p-5 bg-white rounded-md"
              style={{ marginLeft: 0, marginRight: 0 }}
            >
              <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
                <Row className="bg-white">
                  <Col
                   xs={24} sm={24} md={4}
                    className="d-flex justify-content-start me-4 bg-white lg:mb-5"
                  >
                    <label className="font-bold">
                      Name <span className="text-danger">*</span>
                    </label>
                  </Col>
                  <Col sm={24} xs={24} md={12}>
                    <Form.Item
                      name="title"

                    >
                      <Input
                        size="large"
                        className="rounded border border-1"
                        placeholder="Enter Name"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
                <Row className="bg-white">
                <Col xs={24} sm={24} md={4} className="d-flex justify-content-start">
                  <label className="font-bold" style={{ paddingRight: "73px" }}>
                    Image <span className="text-danger">*</span>
                  </label>
                </Col>
                <Col xs={24} sm={24} md={12}  className="d-flex justify-content-start">
                  <Upload
                    name="file"
                    listType="picture-card"
                    fileList={fileList}
                    onChange={handleImage}
                    maxCount={1} 
                    accept=".png, .jpg, .jpeg"
                  >
                    <div>
                      <BsUpload style={{ fontSize: "20px" }} />
                    </div>
                  </Upload>
                </Col>
                
                </Row>
              </Col>
              <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
                <Row className="bg-white">
                  <Col
                   xs={24} sm={24} md={4}
                    className="d-flex justify-content-start me-4 bg-white lg:mb-5"
                  ></Col>
                  <Col sm={24} xs={24} md={12}>
                    <button className="btn-brand" type="submit" >
                      {loading ? 'Updateing...' : 'Update'}
                    </button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
        </Form>
      )}
    </div>
  );
};

export default AwardEdit;